import React, { useState } from 'react';

const TechnicalStep = ({ onComplete, onBack, initialAnswers }) => {
  const [selectedTechnical, setSelectedTechnical] = useState(
    initialAnswers?.technical || ''
  );

  const technicalStrengths = [
    {
      id: 'jumps',
      emoji: '🚀',
      title: 'Big jumps and traveling',
      description: 'Grand jetés, sissones, covering lots of stage space with power'
    },
    {
      id: 'turns',
      emoji: '🌪️',
      title: 'Fast turns and balances',
      description: 'Pirouettes, chaînés, holding arabesque and attitude balances'
    },
    {
      id: 'adagio',
      emoji: '🕊️',
      title: 'Slow adagio & elegant port de bras',
      description: 'Controlled movements, beautiful arm lines, graceful extensions'
    },
    {
      id: 'acting',
      emoji: '🎭',
      title: 'Expressive acting',
      description: 'Storytelling through movement, character development, emotional connection'
    }
  ];

  const handleSelectTechnical = (technicalId) => {
    setSelectedTechnical(technicalId);
  };

  const handleNext = () => {
    if (selectedTechnical) {
      onComplete({ technical: selectedTechnical });
    }
  };

  return (
    <div className="quiz-step">
      <h2>What comes most naturally to you?</h2>
      <p>Choose the technical aspect that feels like your strongest suit or most enjoyable element.</p>
      
      <div className="options-grid">
        {technicalStrengths.map((tech) => (
          <div
            key={tech.id}
            className={`option-card ${selectedTechnical === tech.id ? 'selected' : ''}`}
            onClick={() => handleSelectTechnical(tech.id)}
          >
            <h3>
              <span className="emoji">{tech.emoji}</span>
              {tech.title}
            </h3>
            <p>{tech.description}</p>
          </div>
        ))}
      </div>

      <div className="quiz-buttons">
        <button className="btn-back" onClick={onBack}>
          ← Back
        </button>
        <button 
          className="btn-next" 
          onClick={handleNext}
          disabled={!selectedTechnical}
        >
          Next Step →
        </button>
      </div>
    </div>
  );
};

export default TechnicalStep; 